import { HTMLAttributes, useState } from 'react';
import { cn } from '@/utils/cn';
import { Icon, icons } from '@/components/common/Icon';
interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  description?: string;
  items: FAQItem[];
}

const FAQAccordionItem = ({ question, answer }: FAQItem) => {
  const [isOpen, setIsOpen] = useState(false);


  return (
    <div className="border-b border-gray-200 last:border-0">
      <button
        className="w-full py-6 flex items-center justify-between text-left"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
        aria-expanded={isOpen}
      >
        <span className="text-lg font-medium text-gray-900">{question}</span>
        <Icon
          icon={isOpen ? icons.remove : icons.add}
          className={cn(
            'w-5 h-5 transition-transform',
            isOpen ? 'text-gray-600' : 'text-gray-400'
          )}
          aria-hidden="true"
        />
      </button>
      <div
        className={cn(
          'overflow-hidden transition-all duration-200 ease-in-out',
          isOpen ? 'max-h-96 opacity-100 mb-6' : 'max-h-0 opacity-0'
        )}
        aria-hidden={!isOpen}
      >
        <div
          className="text-gray-600"
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      </div>
    </div>
  );
};

export const FAQ = ({
  title = 'Frequently asked questions',
  description = "Here's everything you need to know about Cobalt, from features to getting started.",
  items,
  className,
  ...props
}: FAQProps) => {
  return (
    <section className={cn('py-16', className)} {...props}>
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">{title}</h2>
          <p className="text-lg text-gray-600">{description}</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {items.map((item, index) => (
            <FAQAccordionItem key={index} {...item} />
          ))}
        </div>
      </div>
    </section>
  );
};